import createIcon from '../../createIcon';

/**
 * @component @name Balcony
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAgMTBWMTJIOFYxMEgxMFpNMTYgMTJWMTBIMTRWMTJIMTZaTTIxIDE0VjIySDNWMTRINFYxMEM0IDUuNTggNy41OCAyIDEyIDJDMTYuNDIgMiAyMCA1LjU4IDIwIDEwVjE0SDIxWk03IDE2SDVWMjBIN1YxNlpNMTEgMTZIOVYyMEgxMVYxNlpNMTEgNC4wOEM4LjE2IDQuNTYgNiA3LjAzIDYgMTBWMTRIMTFWNC4wOFpNMTMgMTRIMThWMTBDMTggNy4wMyAxNS44NCA0LjU2IDEzIDQuMDhWMTRaTTE1IDE2SDEzVjIwSDE1VjE2Wk0xOSAxNkgxN1YyMEgxOVYxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Balcony = createIcon('Balcony', [
  [
    'path',
    {
      d: 'M10 10V12H8V10H10ZM16 12V10H14V12H16ZM21 14V22H3V14H4V10C4 5.58 7.58 2 12 2C16.42 2 20 5.58 20 10V14H21ZM7 16H5V20H7V16ZM11 16H9V20H11V16ZM11 4.08C8.16 4.56 6 7.03 6 10V14H11V4.08ZM13 14H18V10C18 7.03 15.84 4.56 13 4.08V14ZM15 16H13V20H15V16ZM19 16H17V20H19V16Z',
      key: '183oj8',
    },
  ],
]);

export default Balcony;
